/**
 * Use list of transitions to generate css rules for CSSTransition classes.
 *
 * @private
 * @memberOf generateStyles
 * @param {TransitionDescription[]} transitions
 * @return {*[]}
 */
export function transitionsRules(transitions) {
  const rules = [];

  for (const transition of transitions) {
    const {
      name,
      duration,
      delay,
      rules: transitionRules,
      timingFunction,
    } = transition;

    const transitionProperty = transitionRules
      .map(([propertyName]) => propertyName)
      .join(', ');

    rules.push([
      `.${name}-appear, .${name}-enter`,
      [
        ...transitionRules.map(([propertyName, values]) => {
          return [propertyName, values[0]];
        }),
      ],
    ]);
    rules.push([
      `.${name}-appear-active, .${name}-enter-active`,
      [
        ...transitionRules.map(([propertyName, values]) => {
          return [propertyName, values[1]];
        }),
        ['transition-property', `${transitionProperty}`],
        ['transition-duration', `${duration.enter}ms`],
        ['transition-timing-function', `${timingFunction.enter}`],
        ['transition-delay', `${delay.enter}ms`],
      ],
    ]);
    rules.push([
      `.${name}-appear-done, .${name}-enter-done`,
      [
        ...transitionRules.map(([propertyName, values]) => {
          return [propertyName, values[1]];
        }),
      ],
    ]);

    rules.push([
      `.${name}-exit`,
      [
        ...transitionRules.map(([propertyName, values]) => {
          return [propertyName, values[1]];
        }),
      ],
    ]);
    rules.push([
      `.${transition.name}-exit-active`,
      [
        ...transitionRules.map(([propertyName, values]) => {
          return [propertyName, values[2]];
        }),
        ['transition-property', `${transitionProperty}`],
        ['transition-duration', `${duration.exit}ms`],
        ['transition-timing-function', `${timingFunction.exit}`],
        ['transition-delay', `${delay.exit}ms`],
      ],
    ]);
    rules.push([
      `.${transition.name}-exit-done`,
      [
        ...transitionRules.map(([propertyName, values]) => {
          return [propertyName, values[2]];
        }),
      ],
    ]);
  }

  return rules;
}
